import React, {useContext, useEffect, useState} from 'react';
// @ts-ignore
import {useHistory, useLocation, useParams} from "react-router-dom";

import Colors from "../../assets/colors/Colors";
import CountryNavbar from "./Components/CountryNavbar";
import styled from "styled-components";
import {RankingsAndLevelsMapContext} from "../../contexts/RankingsAndLevelsMapContext";
import {RankingsAndLevelsContext} from "../../contexts/RankingsAndLevelsContext";
import RankingsAndLevelsUtils from "../../services/RankingsAndLevelsUtils";
import Constants from "../../data/Constants";
import CountryComponent from "./Components/CountryComponent";
import {GlobalDataContext} from "../../contexts/GlobalDataContext";
import {CountryPathAndReportProps} from "../../interfaces/RankingsAndLevelsInterfaces";

const CountryContainerDiv = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1% 2%;
    background-color: ${(props: {isLife: string}) => (props.isLife ? Colors.backgroundGray: Colors.backgroundWhite)};

    * {
        color: ${(props: {isLife: string}) => (props.isLife ? Colors.fontWhite: Colors.fontGray)};
    }
`;

const baseUrl = Constants.routes.rankingsCountry;

const CountryContainer: React.FC = () => {
    let { countryCode } = useParams();
    let history = useHistory();
    let location = useLocation();

    //@ts-ignore
    let {country, setCountry } = useContext(RankingsAndLevelsMapContext);
    // @ts-ignore
    const { isLife, setIsLife } = useContext(RankingsAndLevelsContext);
    // @ts-ignore
    const { last10YearReports, lastYearAvailable, allDataLoaded } = useContext(GlobalDataContext);

    const [countryInfo, setCountryInfo] = useState<CountryPathAndReportProps>();

    useEffect(() => {
        setCountry(countryCode);
        RankingsAndLevelsUtils.handleQueryParams(location, history, isLife, setIsLife, baseUrl.replace(':countryCode', countryCode));
    }, []);


    useEffect(() =>{
        if(allDataLoaded){
            const reportInfo = last10YearReports[lastYearAvailable];
            if(country && reportInfo){
                const info = RankingsAndLevelsUtils.getCountryPath(country, reportInfo, isLife);
                if(!info){
                    return history.push('/error');
                }
                setCountryInfo(info);
            }
        }
    }, [allDataLoaded, country]);

    return (
        <CountryContainerDiv isLife={isLife} id='CountryContainerDiv'>
            <CountryNavbar backRoute={Constants.routes.rankingsMap}/>
            <CountryComponent countryInfo={countryInfo} />
        </CountryContainerDiv>
    );
};

export default CountryContainer;
